import React from "react";
import { useLocation } from "@reach/router";
import Helmet from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";

export const SEO: React.FC<{
  type?: string;
  title?: string;
  description?: string;
  image?: string;
}> = ({ type, title, description, image }) => {
  const data: Queries.SeoQuery = useStaticQuery(graphql`
    query Seo {
      strapiHomepage {
        SEO_box {
          SEO_excerpt
          SEO_image {
            localFile {
              publicURL
            }
          }
          SEO_title
        }
      }
    }
  `);
  const { pathname } = useLocation();
  const seo = {
    url: process.env.GATSBY_BASE_URL + pathname,
    title: `${data.strapiHomepage?.SEO_box?.SEO_title}${
      title ? ` | ${title}` : ""
    }`,
    description: description || "Living Media Art",
    type: type || "website",
    image: (process.env.GATSBY_BASE_URL || "") + (image ||  data.strapiHomepage?.SEO_box?.SEO_image?.localFile?.publicURL ),
  };
  return (
    <Helmet>
      <meta property="og:type" content={seo.type} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta name="og:image" content={seo.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:image" content={seo.image} />

      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
    </Helmet>
  );
};
